export class ParentalConsentMapper {
  static toInfo(dto: ParentalConsentDto): ParentalConsentInfo {
    return {
      version: dto.version,
      content: dto.content,
    };
  }
}
